import { REPORT_ACCESS } from './Constants';
export const mapReportToRow = (report, personId) => {
    var _a, _b, _c;
    const isShared = !!((_b = (_a = report.shares) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.length);
    return Object.assign(Object.assign({}, report), { isShared: isShared, isReportOwner: ((_c = report.person) === null || _c === void 0 ? void 0 : _c.id) === personId, favorite: !!report.favorite, privateAccess: !!report.privateAccess, access: isShared ? REPORT_ACCESS.SHARED : !report.privateAccess ? REPORT_ACCESS.COMPANY : REPORT_ACCESS.PRIVATE });
};
